
import * as __star__ from '@clayui/date-picker';

const {
default: __default__,
FirstDayOfWeek,
__esModule
} = __star__;

export {
FirstDayOfWeek,
__esModule
};
export default __default__;
